import _ from 'lodash';
import moment from 'moment';
import React, { PropTypes } from 'react';

const Results = (props) => {
    const { results } = props;
    console.log(results);
    return (
        <div className="results">
            REZULTATY <br />
            {
                _.map(results, (result) => {
                    const value = (result.type === 'Date') ? moment(result.value).format('MM/DD/YYYY') : result.value;

                    return (
                        <div key={result.id}>
                            <div> {result.id} | {value} </div>
                        </div>
                    );
                })
            }
        </div>
    );
};

Results.propTypes = {
    results: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
};

export default Results;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/UI/Results.jsx